import type {ReactNode} from 'react';
import {clsx} from 'clsx';

type ProgressPopoverProps = {
    title: ReactNode;
    metrics: {label: string; value: ReactNode}[];
    className?: string;
};

const ProgressPopover = ({title, metrics, className}: ProgressPopoverProps) => (
    <div
        role="tooltip"
        className={clsx(
            'pointer-events-none max-w-[calc(100vw-1rem)] rounded border border-[var(--ui-border)] bg-[var(--ui-surface)] px-2.5 py-2 text-xs leading-4 text-[var(--ui-text)] shadow-[0_0.25rem_0.75rem_rgb(0_0_0_/_16%)]',
            className ?? 'w-44'
        )}>
        <div className="mb-1.5 border-b border-[var(--ui-border)] pb-1.5 text-[13px] font-semibold">
            {title}
        </div>
        <dl className="m-0 grid gap-1">
            {metrics.map(({label, value}) => (
                <div
                    key={label}
                    className="flex items-baseline justify-between gap-3">
                    <dt className="min-w-0 font-normal text-[var(--ui-text-secondary)]">
                        {label}
                    </dt>
                    <dd className="m-0 shrink-0 whitespace-nowrap font-semibold tabular-nums">
                        {value}
                    </dd>
                </div>
            ))}
        </dl>
    </div>
);

export default ProgressPopover;
